<template>
  <v-container fill-height fluid class="d-table-fixed pa-0">
    <div class="d-table-header-group">
      <v-card class="mb-2">
        <v-row class="ma-0 py-1 pl-1">
          <v-col cols="auto" class="pa-0">
            <v-btn
                icon
                color="primary"
                @click="$router.push({name: 'dashboard', params: { reload: search ? false : true } })">
              <v-icon size="30">mdi-arrow-left-circle</v-icon>
            </v-btn>
          </v-col>
          <v-col class="pa-0 pl-1" style="padding-top: 0.1rem !important;">
            <v-row class="ma-0" dense>
              <v-col class="d-flex align-center pa-0">
                <span class="text-h5 font-weight-black">
                  {{ houseBl.documentNbr }}
                </span>
              </v-col>
              <v-col class="d-flex align-center pa-0">
                <span class="text-h5 primary--text font-weight-black">
                  {{ matchedPartyName }}
                </span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </div>

    <v-card width="100%" class="d-table-fixed fill-height">
      <v-tabs
          v-model="tab"
          class="d-table-header-group"
          background-color="accent"
          height="2rem"
          fixed-tabs
      >
        <v-tab>{{ $t('label.info') }}</v-tab>
        <v-tab>{{ $t('label.documents') }}</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" style="display: table-row !important;">
        <v-tab-item class="pa-2">
          <HouseBLMainTransportSea
              :houseBl="houseBl"
              v-if="houseBl.id"
          />
        </v-tab-item>
        <v-tab-item class="pa-2">
          <HouseBLDocuments
              :pratica="houseBl"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
import {mapState} from 'vuex'
import {dateFilter} from '@/filters/dateFilter'
import {houseBLService} from "../../../../services/houseBL.service";
import HouseBLMainTransportSea from "./HouseBLMainTransportSea";
import HouseBLDocuments from "./HouseBLDocuments";

export default {
  name: 'HouseBLPage',
  props: ['id'],
  components: {
    HouseBLMainTransportSea,
    HouseBLDocuments
  },
  data() {
    return {
      tab: null,
      houseBl: {},
    }
  },
  computed: {
    ...mapState('account', ['user', 'userAuthorizations', 'internalVisibilityAuth']),
    ...mapState('searchbar', ['search']),
    matchedPartyName() {
      const checks = [
        {
          list: this.user.shippers,
          target: this.houseBl.shipperId,
          field: 'customerName'
        },
        {
          list: this.user.consignees,
          target: this.houseBl.consigneeId,
          field: 'customerName'
        },
        {
          list: this.user.customers,
          target: this.houseBl.clientFmId,
          field: 'customerName'
        },
        {
          list: this.user.clientsTo,
          target: this.houseBl.clientToId,
          field: 'customerName'
        },
      ]

      for (const check of checks) {
        const match = check.list?.find(
            item => item.id === check.target
        )

        if (match) {
          return match[check.field]
        }
      }

      return null
    }
  },
  methods: {
    init() {
      this.loadHouseBl()
    },
    loadHouseBl() {
      houseBLService.getHouseBLById(this.id).then((resp) => {
        if (!resp) return
        this.houseBl = resp
      })
    },
    formatDate(value) {
      return dateFilter.formatDateDay(value)
    },
  },
  created() {
    this.init()
  },
}
</script>

<style scoped>
.v-tabs-items {
  display: grid !important;
}

.v-tabs-items::v-deep .v-window__container {
  height: 100%;
}

.v-tabs-items::v-deep .v-window-item {
  height: 100%;
}

.v-application .text-overline {
  line-height: 0 !important;
}

/* .col {
  border: solid 1px orange;
} */
</style>
